import { Dropdown } from 'react-bootstrap';
import React, { useCallback, useState } from 'react';
import { DropdownCustomToggle } from '../common/Dropdown';
import { FileIcon, FileUploadIcon, FolderIcon } from './FileExplorerIcons';
import { FileExplorerVisualizerActions } from '../../types/fileExplorerTypes';
import { UploadFolderModal } from './Modals/UploadFolderModal';
import { UploadFileModal } from './Modals/UploadFileModal';
import { useFileExplorerContext } from '../../hooks/useFileExplorerContext';

export function FileExplorerDropdown() {
  const { activeFolder, userIsSuperuser } = useFileExplorerContext();
  const [action, setAction] = useState<FileExplorerVisualizerActions | null>(null);
  const handleHide = useCallback(() => setAction(null), []);

  const can_write = activeFolder?.permissions.can_write ?? false;
  const isDisabled = !can_write && !userIsSuperuser;

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as={DropdownCustomToggle}
          className={`file-explorer-dropdown btn-info ${isDisabled ? 'disabled' : ''}`}
          id="file-explorer-dropdown-toggle"
        >
          <FileUploadIcon />
          Subir archivo
          {' '}
          {userIsSuperuser && 'o crear carpeta'}
        </Dropdown.Toggle>

        {!isDisabled && (
          <Dropdown.Menu>
            {userIsSuperuser && (
              <Dropdown.Item
                eventKey="folder.create"
                onClick={() => setAction('folder.create')}
              >
                <FolderIcon />
                Crear carpeta
              </Dropdown.Item>
            )}
            {can_write && (
              <Dropdown.Item
                eventKey="file.create"
                onClick={() => setAction('file.create')}
                disabled={!activeFolder}
              >
                <FileIcon />
                Subir archivo
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        )}
      </Dropdown>

      <UploadFolderModal
        show={action === 'folder.create'}
        onHide={handleHide}
      />
      <UploadFileModal
        show={action === 'file.create'}
        onHide={handleHide}
      />
    </>
  );
}
